<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-card">
        <div class="auth-header">
          <a href="/" class="logo-link">
            <img src="/static/favicon/favicon-76x76.png" alt="Logo" class="logo">
          </a>
          <h2 class="auth-title">Create Account</h2>
          <p class="auth-subtitle">Start your trading journey today</p>
        </div>

        <div class="auth-body">
          <form onsubmit="return false;">
            <div class="form-group">
              <label for="username">Full Name</label>
              <div class="input-wrapper">
                <i class="bi bi-person"></i>
                <input v-model="name" type="text" id="username" placeholder="Enter your name" required>
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <div class="input-wrapper">
                <i class="bi bi-envelope"></i>
                <input v-model="email" type="email" id="email" placeholder="Enter your email" required>
              </div>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <div class="input-wrapper">
                <i class="bi bi-lock"></i>
                <input v-model="password" type="password" id="password" placeholder="Create a password" required>
              </div>
            </div>
            <p class="error-msg" v-if="errorMsg">{{ errorMsg }}</p>
            <button type="submit" class="btn-primary-auth" @click="signUp">
              <span>Create Account</span>
              <i class="bi bi-arrow-right"></i>
            </button>
          </form>

          <div class="divider" v-if="!isApp">
            <span>or continue with</span>
          </div>

          <div id="g_id_onload" v-if="!isApp"
              data-client_id="815898526228-o18ms44nkoj5c5he3j830movqfpa6qej.apps.googleusercontent.com"
              data-context="signup"
              data-ux_mode="popup"
              data-callback="onSignIn"
              data-auto_select="true"
              data-itp_support="true">
          </div>

          <div class="social-login" v-if="!isApp">
            <div class="g_id_signin d-flex justify-content-center"
                data-type="standard"
                data-shape="rectangular"
                data-theme="outline"
                data-text="signup_with"
                data-size="large"
                data-logo_alignment="left">
            </div>
          </div>
        </div>

        <div class="auth-footer">
          <div class="signin-prompt">
            Already have an account?
            <a href="/signin">Sign In</a>
          </div>
        </div>
      </div>
    </div>

    <!-- OTP Modal -->
    <div class="modal-overlay" v-if="otpModal" @click.self="otpModal = false; errorMsg2 = ''; otp = ''">
      <div class="modal-container">
        <div class="modal-header">
          <h5>Verify Email</h5>
          <button type="button" class="btn-close" @click="otpModal = false; errorMsg2 = ''; otp = ''" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form onsubmit="return false;">
            <div class="otp-sent-msg">
              <i class="bi bi-envelope-check"></i>
              <p>OTP has been sent to <strong>{{ email }}</strong></p>
            </div>

            <div class="form-group">
              <label>Enter 6-digit OTP</label>
              <input type="text" v-model="otp" class="otp-input" maxlength="6" pattern="\d{6}" placeholder="------" required>
            </div>

            <p class="error-msg" v-if="errorMsg2">{{ errorMsg2 }}</p>

            <button type="button" class="btn-primary-auth" @click="signUpValid">Verify & Continue</button>

            <div class="resend-link">
              Didn't receive the OTP?
              <a @click="resend">Resend</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { signUp, signUpValid, authGoogle, resend } from '@/service/restService'
export default {
  name: 'SignUp',
  props: {

  },
  data () {
    return {
      name: '',
      email: '',
      password: '',
      errorMsg: '',
      errorMsg2: '',
      otpModal: false,
      uid: '',
      otp: '',
      user: null,
      isApp: false
    }
  },
  created () {
    // if (window.google && !document.getElementById('g_id_onload')) {
    //   this.$router.go(0)
    // }
    this.isApp = this.isWebView()
    window.onSignIn = user => {
      this.googleLogin(user)
    }
  },
  mounted () {

  },
  methods: {
    resend: function () {
      var obj = {uuid: this.uid}
      this.errorMsg2 = ''
      resend(obj).then((response) => {
        this.errorMsg2 = 'Otp has been re-sent!'
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    },
    googleLogin (response) {
      var obj = {token: response.credential}
      authGoogle(obj).then((response) => {
        this.errorMsg = ''
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('expiryEpoch', response.data.expiryEpoch)
        if (this.isMobile()) {
          this.$router.push('/mw')
        } else {
          this.$router.push('/orders')
        }
      }).catch((error) => {
        this.errorMsg = error.response.data.message[0]
      })
    },
    signUpValid: function () {
      if (!this.otp) {
        this.errorMsg2 = 'Please enter your otp'
        return
      }
      if (this.otp.length <= 5) {
        this.errorMsg2 = 'Your otp needs to be minimum 6  characters long'
        return
      }
      var obj = { uuid: this.uid, otp: this.otp }
      signUpValid(obj).then((response) => {
        this.errorMsg2 = ''
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('refreshToken', response.data.refreshToken)
        localStorage.setItem('expiryEpoch', response.data.expiryEpoch)
        if (this.isMobile()) {
          this.$router.push('/mw').then(() => {
            window.location.reload()
          })
        } else {
          this.$router.push('/orders')
        }
        this.otpModal = false
      }).catch((error) => {
        this.errorMsg2 = error.response.data.message[0]
      })
    },
    signUp: function () {
      if (!this.name) {
        this.errorMsg = 'Please enter your name'
        return
      }
      if (this.name.length <= 3) {
        this.errorMsg = 'Your name needs to be minimum 4  characters long'
        return
      }
      if (!this.email) {
        this.errorMsg = 'Please enter your email Id'
        return
      }
      if (!this.email.match('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}')) {
        this.errorMsg = 'Please enter a valid email address'
        return
      }
      if (!this.password) {
        this.errorMsg = 'Please enter your password'
        return
      }
      if (this.password.length < 6) {
        this.errorMsg = '"Your password needs to be between 6 and 20 characters long'
        return
      }
      var splitName = this.name.split(' ')
      var fName = this.name
      var sName = ''
      if (splitName.length > 1) {
        fName = splitName[0]
        sName = splitName[1]
      }
      var obj = { firstName: fName, lastName: sName, password: this.password, emailId: this.email }
      signUp(obj).then((response) => {
        this.uid = response.data.uuid
        this.errorMsg = ''
        this.otpModal = true
      }).catch((error) => {
        this.errorMsg = error.response.data.message[0]
      })
    }
  }
}
</script>
<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.auth-container {
  width: 100%;
  max-width: 420px;
}

.auth-card {
  background: var(--bs-body-bg);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.auth-header {
  text-align: center;
  padding: 30px 30px 20px;
}

.logo-link {
  display: inline-block;
  margin-bottom: 16px;
}

.logo {
  width: 60px;
  height: 60px;
  border-radius: 12px;
}

.auth-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--bs-body-color);
  margin: 0 0 8px;
}

.auth-subtitle {
  font-size: 14px;
  color: var(--bs-secondary-color);
  margin: 0;
}

.auth-body {
  padding: 0 30px 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--bs-body-color);
  margin-bottom: 6px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper i {
  position: absolute;
  left: 14px;
  color: var(--bs-secondary-color);
  font-size: 16px;
}

.input-wrapper input {
  width: 100%;
  padding: 12px 14px 12px 42px;
  border: 1px solid var(--bs-border-color);
  border-radius: 10px;
  font-size: 14px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.error-msg {
  color: #dc3545;
  font-size: 13px;
  margin: 8px 0;
}

.btn-primary-auth {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-primary-auth:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.divider {
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--bs-border-color);
}

.divider span {
  padding: 0 12px;
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.social-login {
  margin-top: 16px;
}

.auth-footer {
  padding: 20px 30px;
  background: var(--bs-tertiary-bg);
  text-align: center;
}

.signin-prompt {
  font-size: 13px;
  color: var(--bs-secondary-color);
}

.signin-prompt a {
  color: #667eea;
  font-weight: 600;
  text-decoration: none;
}

.signin-prompt a:hover {
  text-decoration: underline;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-container {
  background-color: var(--bs-body-bg);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 420px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--bs-border-color);
}

.modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.modal-body {
  padding: 24px;
}

.otp-sent-msg {
  text-align: center;
  padding: 16px;
  background: rgba(11, 218, 81, 0.1);
  border-radius: 10px;
  margin-bottom: 20px;
}

.otp-sent-msg i {
  font-size: 32px;
  color: #0BDA51;
  margin-bottom: 8px;
}

.otp-sent-msg p {
  margin: 0;
  font-size: 13px;
  color: var(--bs-body-color);
}

.modal-body .form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--bs-border-color);
  border-radius: 10px;
  font-size: 14px;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
}

.modal-body .form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.otp-input {
  text-align: center;
  letter-spacing: 8px;
  font-size: 18px;
  font-weight: 600;
}

.resend-link {
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  color: var(--bs-secondary-color);
}

.resend-link a {
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.resend-link a:hover {
  text-decoration: underline;
}

/* Mobile Responsive */
@media (max-width: 480px) {
  .auth-page {
    padding: 15px;
  }

  .auth-header {
    padding: 24px 20px 16px;
  }

  .auth-body {
    padding: 0 20px 16px;
  }

  .auth-footer {
    padding: 16px 20px;
  }

  .logo {
    width: 50px;
    height: 50px;
  }

  .auth-title {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/SignUp.vue